import styled from 'styled-components';
import colors from 'constants/colors';

export const RadioContainer = styled.label`

  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
  font-family: sans-serif;

  /* hide the default input */
  .hidden-radio {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* costumed radio */
  .radio-appearance {
    height: 20px;
    width: 20px;
    background-color: transparent;
    border: 2px solid ${colors.white};
    border-radius: 50%;
    display: inline-block;
    position: relative;
    transition: all 0.2s ease;
    margin-right: 8px;
  }

  /* checked radio color */
  .hidden-radio:checked + .radio-appearance {
    border-color: ${colors.lightBlue};
  }

  /* checked radio center */
  .radio-appearance::after {
    content: "";
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${colors.lightBlue};
    transform: translate(-50%, -50%);
  }

  .hidden-radio:checked + .radio-appearance::after {
    display: block;
  }

  /* radio hover */
  .custom-radio-wrapper:hover .radio-appearance {
    background-color: ${colors.silver};
  }

  ${({ additionalstyle }) => additionalstyle};
`;